import {getContext, hasContext, setContext} from 'svelte';
import type {Readable, Writable} from 'svelte/store';
import {writable} from 'svelte/store';
import type {CellCoordinates} from 'shared/ui-widgets/grid/types';

const GRID_CELL_CONTEXT_KEY = 'grid-cell-context-key';

type ContentDependentState = Record<'invalid' | 'disabled', boolean>;

export interface GridCellContext {
    coordinates$: Readable<CellCoordinates>;
    contentDependentSate$: Writable<ContentDependentState>;
}

export function setGridCellContext(coordinates$: Readable<CellCoordinates>) {
    const ctx: GridCellContext = {coordinates$, contentDependentSate$: writable({disabled: false, invalid: false})};
    setContext(GRID_CELL_CONTEXT_KEY, ctx);
}

export function getGridCellContext() {
    if (!hasContext(GRID_CELL_CONTEXT_KEY)) {
        throw new Error('Cell context is required!');
    }

    return getContext<GridCellContext>(GRID_CELL_CONTEXT_KEY);
}